<template>
    <el-button
    class="ps-save"
      type="primary"
      size="mini"
      :loading="loading"
      @click="childclick"
      icon="el-icon-document"
    >
      <slot>保存</slot>
    </el-button>
</template>

<script>
export default {
  components: {},
  props: { loading: Boolean },
  data() {
    return {};
  },
  methods: {
    //
    childclick() {
      this.$emit('click');
      // this.$confirm('确认提交?', '提示', {
      //   cancelButtonText: '取消',
      //   confirmButtonText: '确定',
      //   customClass: 'ps-save-confirm',
      //   confirmButtonClass: 'color',
      //   cancelButtonClass: 'color',
      //   type: 'warning'
      // })
      //   .then(() => {
      //     this.$emit('click');
      //     })
      //   .catch(() => {});
    }
  }
};
</script>
<style lang="scss">
.ps-save-confirm {
  .el-message-box__btns {
    display: flex;
    flex-direction: row-reverse;
  }
  .el-message-box__btns button:nth-child(1) {
    margin-left: 10px;
  }
  .color {
    background-color: #409EFF;
    color: #fff;
    &:hover {
      background-color: #66b1ff;
      color: #fff;
    }
    &:focus {
      background-color: #409EFF;
    }
  }
}
</style>